import React, { useState } from 'react';
import { Calendar, Menu, X } from 'lucide-react';
import { Button } from '../ui/Button';
export function HeaderBookACall() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      setMobileMenuOpen(false);
    }
  };
  const navItems = [{
    label: 'Inicio',
    id: 'hero'
  }, {
    label: 'Beneficios',
    id: 'beneficios'
  }, {
    label: 'Proceso',
    id: 'proceso'
  }, {
    label: 'Resultados',
    id: 'resultados'
  }];
  return <header className="fixed top-0 left-0 right-0 bg-black border-b border-gray-900 z-50 shadow-lg" data-id="element-302">
      <div className="container mx-auto px-4" data-id="element-303">
        <div className="flex items-center justify-between h-14 md:h-16 lg:h-20" data-id="element-304">
          {/* Logo with Text - Left Side */}
          <button onClick={() => scrollToSection('hero')} className="flex items-center gap-2 md:gap-3 focus:outline-none focus:ring-2 focus:ring-[#7FFF00] rounded-lg" data-id="element-305">
            <img src="https://cdn.magicpatterns.com/uploads/pQpn8iHP7HBroEb2DfK46p/WhatsApp_Image_2025-12-04_at_16.35.08.jpg" alt="Info Commerce AI" className="h-7 md:h-9 lg:h-10 w-auto" data-id="element-306" />
            <span className="text-white font-bold text-sm md:text-base lg:text-lg tracking-tight" data-id="element-307">
              Info Commerce AI
            </span>
          </button>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-5 lg:space-x-8" data-id="element-308">
            {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-100 hover:text-[#7FFF00] transition-colors text-sm font-medium" data-id="element-309">
                {item.label}
              </button>)}
            <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" data-id="element-310">
              <Button variant="primary" size="md" className="bg-[#7FFF00] hover:bg-[#6FEF00] text-black font-bold text-sm" leftIcon={<Calendar className="w-4 h-4" data-id="element-312" />} data-id="element-311">
                <span className="hidden lg:inline" data-id="element-313">Agenda tu Llamada</span>
                <span className="lg:hidden" data-id="element-314">Agendar</span>
              </Button>
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden text-white p-2 hover:bg-gray-900 rounded-lg transition-colors" aria-label={mobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} data-id="element-315">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-316" /> : <Menu className="w-6 h-6" data-id="element-317" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && <nav className="md:hidden py-3 border-t border-gray-900" data-id="element-318">
            <div className="flex flex-col space-y-1" data-id="element-319">
              {navItems.map(item => <button key={item.id} onClick={() => scrollToSection(item.id)} className="text-gray-100 hover:text-[#7FFF00] transition-colors text-left py-2.5 px-4 hover:bg-gray-900 rounded-lg text-base font-medium" data-id="element-320">
                  {item.label}
                </button>)}
              <div className="pt-2 px-4" data-id="element-321">
                <a href="https://api.leadconnectorhq.com/widget/bookings/info-commerce-llamada-de-claridad-crea-tu-producto-digital-con-ia" target="_blank" rel="noopener noreferrer" className="block" data-id="element-322">
                  <Button variant="primary" size="md" className="w-full bg-[#7FFF00] hover:bg-[#6FEF00] text-black font-bold" leftIcon={<Calendar className="w-5 h-5" data-id="element-324" />} data-id="element-323">
                    Agenda tu Llamada
                  </Button>
                </a>
              </div>
            </div>
          </nav>}
      </div>
    </header>;
}